import React from 'react';

import {
  InboxItemContentApiVerificationRequest,
  InboxItemContentDataDisputeEmployer,
  InboxItemContentResources,
  InboxItemContentVerificationRequestEmployer,
  InboxItemContentWrapper,
} from 'src/components/inboxItem';
import { VerificationRequestStatusBar } from 'src/components/verificationRequest';
import { InboxItemTypeWithResources } from 'src/constants/inbox';
import { useInboxItemById, useInboxItemParamId } from 'src/hooks/inboxItem';
import { useVerificationRequest } from 'src/hooks/verificationRequest';
import { InboxLayout } from 'src/layouts/InboxLayout';

import { ActivityLogsList } from '../activityLog';

export const InboxPEOStaff: React.FC = () => {
  const inboxItemId = useInboxItemParamId();
  const { inboxItem } = useInboxItemById(inboxItemId);

  const { verificationRequest } = useVerificationRequest({ inboxItemId });

  const verificationRequestStatus = verificationRequest?.status;

  const isVerificationRequestItem =
    inboxItem?.type === InboxItemTypeWithResources.VerificationRequest;

  const inboxItemContent = React.useMemo(() => {
    switch (inboxItem?.type) {
      case InboxItemTypeWithResources.VerificationRequest:
        return <InboxItemContentVerificationRequestEmployer />;
      case InboxItemTypeWithResources.DataDispute:
        return <InboxItemContentDataDisputeEmployer />;
      case InboxItemTypeWithResources.Resources:
        return <InboxItemContentResources />;
      case InboxItemTypeWithResources.ApiVerificationRequest:
        return <InboxItemContentApiVerificationRequest />;
      default:
        return null;
    }
  }, [inboxItem?.type]);

  return (
    <InboxLayout>
      <InboxItemContentWrapper
        statusBar={
          inboxItem?.type === InboxItemTypeWithResources.VerificationRequest && (
            <VerificationRequestStatusBar
              status={verificationRequestStatus}
              isMyVerifyRequest={verificationRequest?.isMyVerifyRequest}
            />
          )
        }
        activityLog={
          <ActivityLogsList inboxItemId={inboxItemId} sanitized={isVerificationRequestItem} />
        }
      >
        {inboxItemContent}
      </InboxItemContentWrapper>
    </InboxLayout>
  );
};
